export const THEME = {
  LUCID: 'lucid',
};

export const isLucidTheme = (theme: string): boolean => {
  return theme === THEME.LUCID;
};
